import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  list: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  listEvent: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  grnHistory: [],
  grnHistoryEvent: cloneDeep(initEvent),
  grnList: {
    data: [],
    event: cloneDeep(initEvent),
  },
  manageStockLogs: {
    logs: {
      data: [],
      meta: cloneDeep(initMeta),
      productData: undefined,
    },
    event: cloneDeep(initEvent),
  },
  productsGrnList: {
    data: [],
    event: cloneDeep(initEvent),
  },
  stockMovement: {
    data: {
      data: [],
      meta: cloneDeep(initMeta),
    },
    event: cloneDeep(initEvent),
  },
  stockConfigData: {
    data: [],
    event: cloneDeep(initEvent),
  },
  deleteEvent: cloneDeep(initEvent),
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getStockListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.list.data = []
        draft.list.meta = cloneDeep(initMeta)
        return draft
      case getType(actions.getStockListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.list.data = response.data
        if (response.meta) {
          draft.list.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getStockListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getStockDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getStockDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        if (response) {
          draft.detail = response
        }
        return draft
      case getType(actions.getStockDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.createStockAction.request):
      case getType(actions.updateStockAction.request):
      case getType(actions.deleteStockAction.request):
      case getType(actions.manageOnlineStockAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.createStockAction.success):
      case getType(actions.updateStockAction.success):
      case getType(actions.manageOnlineStockAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.deleteStockAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'ลบข้อมูลสำเร็จ'
        return draft
      case getType(actions.createStockAction.failure):
      case getType(actions.updateStockAction.failure):
      case getType(actions.deleteStockAction.failure):
      case getType(actions.manageOnlineStockAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getGrnHistoryAction.request):
        draft.grnHistoryEvent = cloneDeep(initEvent)
        draft.grnHistoryEvent.IsLoading = true
        draft.grnHistory = []
        return draft
      case getType(actions.getGrnHistoryAction.success):
        response = action.payload
        draft.grnHistoryEvent.IsLoading = false
        draft.grnHistoryEvent.SubmitSuccess = true
        draft.grnHistory = response.purchasing_history
        return draft
      case getType(actions.getGrnHistoryAction.failure):
        draft.grnHistoryEvent.IsLoading = false
        draft.grnHistoryEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getGrnListAction.request):
        draft.grnList.event = cloneDeep(initEvent)
        draft.grnList.event.IsLoading = true
        draft.grnList.data = []
        return draft
      case getType(actions.getGrnListAction.success):
        response = action.payload
        draft.grnList.event.IsLoading = false
        draft.grnList.event.SubmitSuccess = true
        draft.grnList.data = response.product_grn_items
        return draft
      case getType(actions.getGrnListAction.failure):
        draft.grnList.event.IsLoading = false
        draft.grnList.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getManageStockLogsAction.request):
        draft.manageStockLogs.event = cloneDeep(initEvent)
        draft.manageStockLogs.event.IsLoading = true
        draft.manageStockLogs.logs.data = []
        draft.manageStockLogs.logs.meta = cloneDeep(initMeta)
        return draft
      case getType(actions.getManageStockLogsAction.success):
        response = action.payload
        draft.manageStockLogs.event.IsLoading = false
        draft.manageStockLogs.event.SubmitSuccess = true
        draft.manageStockLogs.logs.data = response.grn_item_logs
        draft.manageStockLogs.logs.productData = response.product
        if (response.meta) {
          draft.manageStockLogs.logs.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getManageStockLogsAction.failure):
        draft.manageStockLogs.event.IsLoading = false
        draft.manageStockLogs.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getProductsGrnListAction.request):
        draft.productsGrnList.event = cloneDeep(initEvent)
        draft.productsGrnList.event.IsLoading = true
        draft.productsGrnList.data = []
        return draft
      case getType(actions.getProductsGrnListAction.success):
        response = action.payload
        draft.productsGrnList.event.IsLoading = false
        draft.productsGrnList.event.SubmitSuccess = true
        draft.productsGrnList.data = response.product_grn_items
        return draft
      case getType(actions.getProductsGrnListAction.failure):
        draft.productsGrnList.event.IsLoading = false
        draft.productsGrnList.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getStockMovementListAction.request):
        draft.stockMovement.event = cloneDeep(initEvent)
        draft.stockMovement.event.IsLoading = true
        draft.stockMovement.data.data = []
        draft.stockMovement.data.meta = cloneDeep(initMeta)
        return draft
      case getType(actions.getStockMovementListAction.success):
        response = action.payload
        draft.stockMovement.event.IsLoading = false
        draft.stockMovement.event.SubmitSuccess = true
        draft.stockMovement.data.data = response.data
        if (response.meta) {
          draft.stockMovement.data.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getStockMovementListAction.failure):
        draft.stockMovement.event.IsLoading = false
        draft.stockMovement.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getStockConfigDetailAction.request):
        draft.stockConfigData.event = cloneDeep(initEvent)
        draft.stockConfigData.event.IsLoading = true
        draft.stockConfigData.data = []
        return draft
      case getType(actions.getStockConfigDetailAction.success):
        response = action.payload
        draft.stockConfigData.event.IsLoading = false
        draft.stockConfigData.event.SubmitSuccess = true
        draft.stockConfigData.data = response?.data || []
        return draft
      case getType(actions.getStockConfigDetailAction.failure):
        draft.stockConfigData.event.IsLoading = false
        draft.stockConfigData.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateConfigStockAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.updateConfigStockAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.updateConfigStockAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.deleteConfigStockAction.request):
        draft.deleteEvent = cloneDeep(initEvent)
        draft.deleteEvent.IsLoading = true
        return draft
      case getType(actions.deleteConfigStockAction.success):
        draft.deleteEvent.IsLoading = false
        draft.deleteEvent.SubmitError = undefined
        draft.deleteEvent.SubmitSuccess = true
        draft.deleteEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.deleteConfigStockAction.failure):
        draft.deleteEvent.IsLoading = false
        draft.deleteEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getCountAction.request):
        draft.countData = undefined
        return draft
      case getType(actions.getCountAction.success):
        response = action.payload
        draft.countData = response.data
        return draft

      case getType(actions.clearEventAction):
        draft.listEvent = cloneDeep(initEvent)
        draft.detailEvent = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.grnList.event = cloneDeep(initEvent)
        draft.productsGrnList.event = cloneDeep(initEvent)
        draft.stockMovement.event = cloneDeep(initEvent)
        draft.deleteEvent = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
